export default "__VITE_ASSET__ChRwy6ix__"